var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "md-layout" }, [
      _c(
        "div",
        { staticClass: "md-layout-item md-size-100 container-buttons" },
        [
          _c(
            "div",
            {
              staticClass: "button-checkbox",
              class: { active: _vm.isCustomer },
              on: { click: _vm.customerCheckbox },
            },
            [_c("span", [_vm._v("Customer")])]
          ),
          _c(
            "div",
            {
              staticClass: "button-checkbox",
              class: { active: _vm.isDriver },
              on: { click: _vm.driverCheckbox },
            },
            [_c("span", [_vm._v("Team Member")])]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }